import { render } from "./MellonWebECRSimpleStatusLabel.vue?vue&type=template&id=49b8289e"
import script from "./MellonWebECRSimpleStatusLabel.vue?vue&type=script&lang=js"
export * from "./MellonWebECRSimpleStatusLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__